import { z } from 'zod';

/*
	https://docs.api.europace.de/privatkredit/vorgaenge/kex-vorgang-update-api/#kontoverbindung

	{
        "antragstellerIds": [ String ],
        "bic": String,
        "iban": String
    }


*/

export const schemaEuropaceUpdateKontoverbindung = z.object({
    antragstellerIds: z.array(z.string().min(1)).min(1).max(2),
    bic: z.optional(z.string()),
    iban: z.optional(z.string()),
});

export type SchemaEuropaceUpdateKontoverbindung = z.infer<typeof schemaEuropaceUpdateKontoverbindung>;
